import { string } from 'prop-types'
import { kuiperClassNames } from '../../utils'
import TextCell from '../TextCell'

const ContentCell = (props) => (
  <TextCell {...props} className={kuiperClassNames('content-cell')} />
)

ContentCell.propTypes = {
  className: string,
}

export default ContentCell
